<template>
    <div>
        <CModal
            :centered="true"
            color="white"
            :show.sync="isShown"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Login using Phone Number</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closeModal()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px;padding-bottom:48px;">
                    <CRow v-if="flagValidation == true">
                        <CCol sm="12" class="text-left">
                            <img class="mt-2 mb-2" @click="move()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
                        </CCol>
                    </CRow>
                    <CRow style="padding-bottom: 8px;">
                        <CCol sm="12">
                            <input v-if="flagValidation == false" placeholder="Input Phone Number" v-model="phoneNumber" class="form-control rounded w-100" type="text" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" />
                            <input v-else placeholder="Code Validation" v-model="codeValidation" class="form-control rounded w-100" type="text" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" />
                        </CCol>
                    </CRow>
                    <CRow style="padding-bottom: 8px;">
                        <CCol sm="12">
                            <span class="text-danger">{{ alertMess }}</span>
                        </CCol>
                    </CRow>
                    <CRow style="padding-bottom: 16px;">
                        <CCol sm="12">
                            <CButton v-if="flagValidation == false" @click="checkPhone()" class="w-100 btn-primary">
                                <span v-if="loadingPhone == false">Check Phone Number</span>
                                <CSpinner v-if="loadingPhone == true" color="default" size="sm"/>
                            </CButton>
                            <CButton v-else @click="checkCode()" class="w-100 btn-primary">
                                <span v-if="loadingCode == false">Submit</span>
                                <CSpinner v-if="loadingCode == true" color="default" size="sm"/>
                            </CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isShown: false,
            closeIcon: require('../../assets/menu/icon_close.svg'),
            backIcon: require('../../assets/menu/icon_goback.svg'),
            phoneNumber: null,
            codeValidation: null,
            flagButton: true,
            flagValidation: false,
            alertMess: '',
            loadingPhone: false,
            loadingCode: false
        }
    },
    watch: {
        flagValidation() {
            this.codeValidation = null
        },
        phoneNumber() {
            this.alertMess = ''
        }
    },
    methods: {
        closeModal() {
            this.isShown = false
            this.phoneNumber = null
            this.flagButton = true
            this.alertMess = ''
            this.flagValidation = false
            this.codeValidation = null
            this.loadingPhone = false
            this.loadingCode = false
        },
        checkPhone() {
            if(this.phoneNumber == null || this.phoneNumber.length < 10) {
                this.alertMess = 'Phone Number Invalid'
            } else {
                this.$emit('checkPhone', this.phoneNumber)
            }
        },
        checkCode() {
            if(this.codeValidation == null || this.codeValidation.length < 6) {
                this.alertMess = 'Code Invalid'
            } else {
                this.$emit('checkCode', this.codeValidation)
            }
        },
        move() {
            this.flagValidation = false
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
@media screen and (min-width: 1097px){
    ::v-deep .modal-dialog {
        max-width: 30% !important;
    }
}
@media screen and (max-width: 1096px){
    ::v-deep .modal-dialog {
        max-width: 100% !important;
    }
}

</style>